// extracted by mini-css-extract-plugin
module.exports = {"root":"MediaFeedList_root__R7gpr","listItem":"MediaFeedList_listItem__tKP2a","rootCarousel":"MediaFeedList_rootCarousel__S2Ytd","slider":"MediaFeedList_slider__Gs9e8"};